import styled from "styled-components"
import { Header } from "./Header"

const Content = styled.main`
  max-width: 800px;
  margin: 80px auto;
  padding: 0 16px;
  box-sizing: border-box;
  font-family: "Franklin Gothic Medium", "Arial Narrow", Arial, sans-serif;

  h1 {
    font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  }
`

export function Layout({ children }) {
  return (
    <>
      <Header />
      <Content>{children}</Content>
    </>
  )
}
